<script setup lang="ts">
import { getCurrentInstance, computed, watch } from 'vue';

const { proxy } = getCurrentInstance();
const store = proxy.$store;

const dialog = computed({
  get() {
    return store.state.profile.dashboard.dialog === 'selfReactivated';
  },
  set(value: boolean) {
    store.commit('profile/dashboard/setDialog', value);

    if (!value) {
      store.commit('auth/setIsSelfReactivated', false);
    }
  }
});

const dialogTitle = computed(() => {
  return proxy.$t('selfReactivated.title') as string;
});

const buttons = [
  {
    events: {
      click: () => {
        dialog.value = false;
      }
    },
    text: proxy.$t('selfReactivated.primaryButtonText')
  }
];

watch(dialog, value => {
  if (value) {
    setTimeout(() => proxy.$eventHub.$emit('playConfettiSelfReactivated'), 500);
  }
});
</script>

<template>
  <UlDialog v-model="dialog" :title="dialogTitle" :buttons="buttons" header-type="information">
    <template #leftIcon>
      <Confetti event-name="playConfettiSelfReactivated" class="icon_56" />
    </template>
    <template #text>
      <div class="mb-8 mb-md-6" v-html="$t('selfReactivated.perex')"></div>
    </template>
  </UlDialog>
</template>

<style scoped lang="scss">

</style>
